// let hostname = window.location.hostname
// let protocol = window.location.protocol
// let parts = hostname.split('.')
// let subdomain = ''
// if (parts.length >= 3) subdomain = parts[0]
// export const baseURL = protocol + '//' + hostname
//export const baseURL = "https://be-develop.lilasignal.com";
export const baseURL = process.env.REACT_APP_PRO_MODE;
//export const baseURL = "https://be-sgnl-57-tracker-request-validation.lilasignal.com";

// export const subDomain = subdomain
